import { ContractorApiListSharedType } from '../../types';

type ShareItem = ContractorApiListSharedType['listShareItem'][number];

const getShareItemKey = (shareItem: ShareItem) => `${shareItem.shareId}:${shareItem.id}`;

export const getListDataAfterShareItemsDelete = (
    listData: ContractorApiListSharedType,
    deletedShareItems: ShareItem[],
): ContractorApiListSharedType => {
    const deletedShareItemKeys = new Set(deletedShareItems.map(getShareItemKey));
    const listShareItem = listData.listShareItem.filter(
        (shareItem) => !deletedShareItemKeys.has(getShareItemKey(shareItem)),
    );
    const activeRecipientIds = new Set(listShareItem.map((shareItem) => shareItem.rid));
    const activeSharerIds = new Set(listShareItem.map((shareItem) => shareItem.sid));
    const activeResourceIds = new Set(listShareItem.map((shareItem) => shareItem.id));
    const activeShareIds = new Set(listShareItem.map((shareItem) => shareItem.shareId));

    return {
        ...listData,
        listShare: listData.listShare.filter((share) => activeShareIds.has(share.id)),
        listRecipient: listData.listRecipient.filter((recipient) => activeRecipientIds.has(recipient.id)),
        listSharer: (listData.listSharer ?? []).filter((sharer) => activeSharerIds.has(sharer.id)),
        listDocument: listData.listDocument.filter((document) => activeResourceIds.has(document.id)),
        listFolder: listData.listFolder.filter((folder) => activeResourceIds.has(folder.uuid)),
        listShareItem,
    };
};
